<template>
    <b-list-group
        class="mt-2"
    >
        <b-list-group-item
            variant="secondary"
        >
            <font-awesome-icon
                icon="child"
                class="mr-2"
            ></font-awesome-icon>
            Students
            <router-link
                :to="{ name: 'form', params: { formKey: 'AddStudentForm' } }"
                variant="primary"
                class="float-right"
            >
                <font-awesome-icon
                    icon="plus"
                ></font-awesome-icon>
                Add Student
            </router-link>
        </b-list-group-item>
        <b-list-group-item
            v-for="(student, idx) in students"
            v-bind:key="idx"
            :to="{ name: 'register_student', params: { id: student.id }, query: { back: '/register' } }"
        >    
            {{ student.first_name }}
            <b-check
                v-if="!loadingStudentStatus"
                :checked="student.enrolled"
                :disabled="true"
                class="float-right"
            ></b-check>
            <b-spinner
                v-else
                variant="dark"
                class="float-right"
                small
            ></b-spinner>
        </b-list-group-item>
    </b-list-group>
</template>
<script>
import { mapState } from 'vuex';
export default {
    props: ["semester"],
    data()  {
        return {
            loadingStudentStatus: false,
        };
    },
    mounted()  {
        this.getStudentStatus();
    },
    methods: {
        getStudentStatus() {
            this.loadingStudentStatus = true;
            this.$api.get("/api/register/get-students").then((response) => {
                const data = response.data;
                if (data.students.length) {
                    this.$store.commit("updateStudents", data);
                }
                this.loadingStudentStatus = false;
            });
        }
    },
    computed: mapState(["students"])
}
</script>